export default __webpack_public_path__ + "static/media/24H_Grey.900ccaab.png";